import type { SxProps } from '@mui/material';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import clsx from 'clsx';
import React from 'react';

interface Props {
  sx?: SxProps;
  className?: string;
}

export default function CateRadioBtns(props: Props) {
  const { sx, className } = props;
  const [value, setValue] = React.useState('recent');
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <Box className={clsx('CateRadioBtns-root', className)} sx={flatSx({}, sx)}>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={handleChange}
        row
      >
        <FormControlLabel value="recent" control={<Radio size="small" />} label="최신순" />
        <FormControlLabel value="popular" control={<Radio size="small" />} label="인기순" />
      </RadioGroup>
    </Box>
  );
}
